import { render, staticRenderFns } from "./IntroJuego.vue?vue&type=template&id=5b90baa3&"
import script from "./IntroJuego.vue?vue&type=script&lang=js&"
export * from "./IntroJuego.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports